<app-table
  [config]="config"
  [customCellTemplateRef]="customCellTemplateRef"
  [customCollectionActionsTemplateRef]="customCollectionActionsTemplateRef" />

<ng-template
  #customCellTemplateRef
  let-column="column"
  let-model="model">
  <app-admin-order-list-custom-cell-template
    [column]="column"
    [model]="model" />
</ng-template>

<ng-template
  #customCollectionActionsTemplateRef
  let-selection="selection">
  <app-table-collection-actions
    [actions]="customCollectionActions()"
    [selection]="selection" />
</ng-template>

<p-drawer
  [customCloseEvent]="customClosePartialRefundDrawerEvent"
  [visible]="partialRefundDrawerVisibility()"
  appDrawerSidebar
  position="right"
  size="xl">
  <ng-template #header>
    <app-drawer-title>Częściowy zwrot zamówienia</app-drawer-title>
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      @if (
        partialRefundDrawerVisibility() && partialRefundOrderId();
        as orderId
      ) {
        <app-admin-order-partial-refund-form
          (cancelEvent)="handlePartialRefundCancelEvent()"
          (submitEvent)="handlePartialRefundSubmitEvent()"
          [id]="orderId" />
      }
    </app-drawer-content>
  </ng-template>
</p-drawer>
